import {Component, EventEmitter, Input, OnDestroy, Output} from '@angular/core';

@Component({
    selector: 'app-shared-custom-search',
    templateUrl: './shared-custom-search.component.html',
    styleUrls: ['./shared-custom-search.component.scss'],
    standalone: false
})
export class SharedCustomSearchComponent implements OnDestroy {
  @Input() placeholder: string;
  @Input() debounce = 250;
  @Output() readonly searchChange = new EventEmitter<string>();

  /**
   * Bound to the input; parent updates via searchAll only when the field is not focused.
   */
  searchValue = '';

  private debounceId: ReturnType<typeof setTimeout> | null = null;
  private isInputFocused = false;

  get searchAll(): string {
    return this.searchValue;
  }

  @Input()
  set searchAll(value: string) {
    if (!this.isInputFocused) {
      this.searchValue = value ?? '';
    }
  }

  onInputFocus(): void {
    this.isInputFocused = true;
  }

  onInputBlur(): void {
    this.isInputFocused = false;
  }

  clearSearch(): void {
    this.searchValue = '';
    if (this.debounceId) {
      clearTimeout(this.debounceId);
      this.debounceId = null;
    }
    this.searchChange.emit(this.searchValue);
  }

  onSearchChange(): void {
    if (this.debounceId) {
      clearTimeout(this.debounceId);
    }
    this.debounceId = setTimeout(() => {
      this.searchChange.emit(this.searchValue);
      this.debounceId = null;
    }, this.debounce);
  }

  ngOnDestroy(): void {
    if (this.debounceId) {
      clearTimeout(this.debounceId);
    }
  }

}
